import { useEffect } from 'react'

export function useExitIntent({
  onExitIntent,
  inactivityMs = 20000,
  scrollThreshold = 200,
  scrollSpeedMs = 300,
}) {
  useEffect(() => {
    let timeout = setTimeout(onExitIntent, inactivityMs)
    // let fired = sessionStorage.getItem('exitIntentPopupTriggered') === 'true'
    let fired = false
    const safeTrigger = () => {
      // if (!fired) {
      //   // fired = true
      //   sessionStorage.setItem('exitIntentPopupTriggered', 'true') // optional
      //   onExitIntent()
      // }
      onExitIntent()
    }

    let lastScrollY = window.scrollY
    let lastScrollTime = Date.now()
    let hitBottom = false
    let bottomY = 0

    const resetInactivityTimer = () => {
      clearTimeout(timeout)
      timeout = setTimeout(onExitIntent, inactivityMs)
    }

    const handleMouseOut = (e) => {
      // Trigger if the mouse leaves the document (e.g. to address bar, tabs, etc.)
      if (!e.relatedTarget && e.clientY <= 0) {
        safeTrigger()
      }
    }

    const handleScroll = () => {
      const now = Date.now()
      const currentY = window.scrollY
      const deltaY = Math.abs(currentY - lastScrollY)
      const deltaTime = now - lastScrollTime

      const scrollHeight = document.documentElement.scrollHeight
      const viewportHeight = window.innerHeight
      const maxY = scrollHeight - viewportHeight
      const atBottom = currentY + viewportHeight >= scrollHeight - 50

      // Fast scroll trigger
      if (deltaY > scrollThreshold && deltaTime < scrollSpeedMs) {
        safeTrigger()
      }

      // Detect bottom
      if (atBottom && !hitBottom) {
        hitBottom = true
        bottomY = currentY
      }

      // After hitting bottom, if they scroll back up ≥25% of the way
      if (hitBottom) {
        const backUpDistance = bottomY - currentY
        if (backUpDistance >= 0.25 * bottomY) {
          safeTrigger()
          hitBottom = false
        }
      }

      lastScrollY = currentY
      lastScrollTime = now
      resetInactivityTimer()
    }

    const handleVisibilityChange = () => {
      if (document.visibilityState === 'hidden') {
        safeTrigger()
      }
    }

    const handlePopState = () => {
      safeTrigger()
    }

    // Inactivity
    ;['mousemove', 'keydown', 'scroll', 'touchstart'].forEach((evt) =>
      window.addEventListener(evt, resetInactivityTimer)
    )

    // Scroll intent
    window.addEventListener('scroll', handleScroll, { passive: true })

    // Tab/app switch
    document.addEventListener('visibilitychange', handleVisibilityChange)

    // Mouse leaves document (e.g. to address bar, tabs, etc.)
    window.addEventListener('mouseout', handleMouseOut)

    // Android back button
    window.addEventListener('popstate', handlePopState)

    return () => {
      clearTimeout(timeout)
      ;['mousemove', 'keydown', 'scroll', 'touchstart'].forEach((evt) =>
        window.removeEventListener(evt, resetInactivityTimer)
      )
      window.removeEventListener('mouseout', handleMouseOut)
      window.removeEventListener('scroll', handleScroll)
      document.removeEventListener('visibilitychange', handleVisibilityChange)
      window.removeEventListener('popstate', handlePopState)
    }
  }, [onExitIntent, inactivityMs, scrollThreshold, scrollSpeedMs])
}
